var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcActionOsmandMapsPlus({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 11C2 5.47715 6.47715 1 12 1C17.5228 1 22 5.47715 22 11C22 15.1435 19.4799 18.6984 15.8889 20.2157C14.3611 20.8612 13.25 21.4167 12.9722 22.5278C12.8333 23.0833 12.4861 23.5 12 23.5C11.5139 23.5 11.1667 23.0833 11.0278 22.5278C10.75 21.4167 9.63889 20.8612 8.11111 20.2157C4.52006 18.6984 2 15.1435 2 11ZM12 16C14.7614 16 17 13.7614 17 11C17 8.23858 14.7614 6 12 6C9.23858 6 7 8.23858 7 11C7 13.7614 9.23858 16 12 16Z",
    fill: "url(#paint0_linear_9_8004)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 11C17 13.7614 14.7614 16 12 16C9.23858 16 7 13.7614 7 11C7 8.23858 9.23858 6 12 6C14.7614 6 17 8.23858 17 11Z",
    fill: "url(#paint1_linear_9_8004)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19 1C19.5523 1 20 1.44772 20 2V4H22C22.5523 4 23 4.44772 23 5C23 5.51768 22.6067 5.94379 22.1025 5.99512L22 6H20V8C20 8.55228 19.5523 9 19 9C18.4477 9 18 8.55228 18 8V6H16L15.8975 5.99512C15.3933 5.94379 15 5.51768 15 5C15 4.48232 15.3933 4.05621 15.8975 4.00488L16 4H18V2C18 1.44772 18.4477 1 19 1Z",
    fill: "url(#paint2_linear_9_8004)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9_8004",
    x1: 12,
    y1: 1,
    x2: 12,
    y2: 23.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAC4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9_8004",
    x1: 12,
    y1: 6,
    x2: 12,
    y2: 16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B35F00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC6D00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_9_8004",
    x1: 19,
    y1: 1,
    x2: 19,
    y2: 9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#732EEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5714CC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcActionOsmandMapsPlus);
export default __webpack_public_path__ + "static/media/ic_action_osmand_maps_plus.b38813df292c6ffe1653e6acf600788f.svg";
export { ForwardRef as ReactComponent };